import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  Button,
  IconActions,
  IconDelete,
  IconEdit,
  Label,
  TextInput,
  Notification,
  ConfirmationPopup
} from 'shared/components'
import { deleteCustomFieldEnum, updateCustomFieldEnum } from 'src/product/actions'
import './styles.scss'

const CustomFieldEnumTag = ({ value, enumId, companyId, onDelete }) => {
  const [showMenu, setShowMenu] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [showEditForm, setShowEditForm] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [editValue, setEditValue] = useState(value)

  const toggleMenu = () => setShowMenu(!showMenu)

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await deleteCustomFieldEnum(enumId, companyId)
      onDelete(enumId)
      Notification('success', __('Allowed value deleted'))
    } catch (error) {
      Notification('error', __('Error occurred'), __('Could not delete the allowed value'))
    }
    setIsDeleting(false)
    setShowDeleteConfirm(false)
  }

  const handleEdit = async () => {
    if (!editValue.trim()) {
      return
    }
    setIsEditing(true)
    try {
      await updateCustomFieldEnum(enumId, { value: editValue.trim() }, companyId)
      onDelete() // This will refresh the list
      setShowEditForm(false)
      Notification('success', __('Allowed value updated'))
    } catch (error) {
      Notification('error', __('Error occurred'), __('Could not update the allowed value'))
    }
    setIsEditing(false)
  }

  return (
    <>
      <div className='custom-field-enum-tag'>
        <span className='tag-value'>{value}</span>
        <button
          className='table-select'
          aria-label='Select enum'
          onClick={toggleMenu}
          type='button'
        >
          <IconActions stroke='#2e86de' height='14px' width='14px' />
        </button>
        {showMenu && (
          <Modal confirmCb={() => {}} hideFooter closeCb={toggleMenu} size='sm'>
            <div className='DeviceActionMenu CustomFieldEnumActionMenu'>
              <div className='header'>
                <Label text='Allowed Value' />
                <div className='text'>{value}</div>
              </div>
              <ul className='inner-menu'>
                <li>
                  <Button
                    className='table-button'
                    type='button'
                    theme='info'
                    size='sm'
                    onClick={() => {
                      setShowMenu(false)
                      setShowEditForm(true)
                    }}
                  >
                    <>
                      <IconEdit height='16px' width='16px' />
                      <span>{__('Edit')}</span>
                    </>
                  </Button>
                </li>
                <li>
                  <Button
                    className='table-button'
                    type='button'
                    theme='error'
                    size='sm'
                    onClick={() => {
                      setShowMenu(false)
                      setShowDeleteConfirm(true)
                    }}
                  >
                    <>
                      <IconDelete height='16px' width='16px' />
                      <span>{__('Delete')}</span>
                    </>
                  </Button>
                </li>
              </ul>
            </div>
          </Modal>
        )}
      </div>

      {showDeleteConfirm && (
        <ConfirmationPopup
          title={__('Delete Allowed Value')}
          text={__('Are you sure you want to delete this allowed value?')}
          confirmCb={handleDelete}
          closeCb={() => setShowDeleteConfirm(false)}
          isLoading={isDeleting}
        />
      )}

      {showEditForm && (
        <Modal
          title={__('Edit Allowed Value')}
          confirmCb={handleEdit}
          closeCb={() => setShowEditForm(false)}
          disabled={isEditing}
          size='sm'
        >
          <div className='edit-form'>
            <Label text={__('Value')} />
            <TextInput
              value={editValue}
              onChange={e => setEditValue(e.target.value)}
              placeholder={__('Enter allowed value')}
            />
          </div>
        </Modal>
      )}
    </>
  )
}

CustomFieldEnumTag.propTypes = {
  value: PropTypes.string.isRequired,
  enumId: PropTypes.number.isRequired,
  companyId: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default CustomFieldEnumTag
